import { Grid, Image, TextPassage } from '@petsmart-ui/sparky';
import type { ReactElement } from 'react';
import type { BenefitsItem, LoyaltyBenefitsItem, LoyaltyImage } from '@libs/contentful';
import './BenefitItems.scss';

const componentClassName = 'benefit-items';

export function BenefitItems({ items }: { items: BenefitsItem[] | LoyaltyBenefitsItem[] }): ReactElement | null {
    return items?.length ? (
        <Grid.Item className={`${componentClassName}`} data-testid="benefit-items">
            {items?.map(item => {
                const fields = item?.fields;

                if (!fields) {
                    return null;
                }

                const isLoyaltyBenefit = 'benefitImage' in fields;

                const imageField = (
                    isLoyaltyBenefit ? (fields?.benefitImage as LoyaltyImage) : fields?.benefitIcon
                ) as LoyaltyImage;
                const textField = (isLoyaltyBenefit ? fields?.benefitDescription : fields?.benefitTitle) as string;
                return (
                    <div key={fields?.identifier} className={`${componentClassName}__item`}>
                        {!!imageField && (
                            <Image
                                className={`${componentClassName}__item--icon`}
                                src={imageField?.fields?.remoteDesktopImageUrl}
                                alt={imageField?.fields?.webAltText}
                                data-testid="benefit-item-image"
                            />
                        )}
                        {!!textField && <TextPassage>{textField}</TextPassage>}
                    </div>
                );
            })}
        </Grid.Item>
    ) : null;
}
